import { ActionButton, BodyText } from '@if/mui'
import { useTheme } from '@mui/material'

interface Props {
  id: string
  text: string
  selected: string
  onChange: (id: string) => void
}

const FeedbackOption = ({ id, text, selected, onChange }: Props) => {
  const theme = useTheme()
  return (
    <ActionButton
      sx={{
        width: '100%',
        textAlign: 'start',
        display: 'flex',
        border: '2px solid',
        borderColor: theme.vars.palette.divider,
        borderRadius: '2rem',
        padding: '1rem',
        marginTop: '1rem',
        justifyContent: 'left',
        color: theme.vars.palette.text.primary,
      }}
      onClick={() => onChange(id)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onChange(id)
        }
      }}
    >
      <div style={{ textAlign: 'right' }}>
        <input
          required
          type="radio"
          id={`feedbackType${id}`}
          name="feedbackType"
          checked={selected === id}
          style={{
            accentColor: theme.vars.palette.secondary.main,
            width: '1.1875rem',
            height: '1.1875rem',
            verticalAlign: 'middle',
            marginRight: '10px',
          }}
          onChange={() => {}} // workaround to a warning in console
        />
        <label
          htmlFor={`feedbackType${id}`}
          style={{ verticalAlign: 'middle', cursor: 'pointer', display: 'inline-block' }}
        >
          <BodyText>{text}</BodyText>
        </label>
      </div>
    </ActionButton>
  )
}

export default FeedbackOption
